<template>
  <div id="fullscreen">
    <!-- <app-chat></app-chat> -->
    <div class="pt-3 text-center pb-3 partnerHome-nav-bar">
      <b-button
        class="partnerHome-nav-button m-0 p-0 ml-5 mb-2 mt-2"
        id="popover-target-1"
        @click="navigatePage('home')"
      >Home</b-button>

      <!-- <b-button class="partnerHome-nav-button m-0 p-0 ml-5 mb-2 mt-2" id="popover-about">About LnT</b-button> -->
      <b-popover
        :show.sync="showPopoverMenu"
        target="popover-about"
        triggers="hover blur"
        placement="top"
        custom-class="about-popover-container"
      >
        <div class="row popover-about">
          <div class="col-9 m-auto mb-0 mt-2">
            <span class="row mt-4">
              <div
                class="popover-menu-item-group cursor-pointer mt-2 pt-2"
                @click="navigatePage('companyOverview')"
              >
                <img class="ml-3 popover-img-company" src="@/assets/dashboard/companyoverview.svg" />
                <p class="popover-text mt-2">Company Overview</p>
                <p class="popover-sub-text pt-1">
                  Larsen & Toubro is a major technology, engineering, construction, manufacturing and financial services conglomerate, with global operations. L&T addresses critical needs in key sectors &
                  <br />More...
                </p>
              </div>
              <!-- <span class="popover-text">Company Overview</span> -->
              <div
                class="popover-menu-item-group cursor-pointer mt-3 pt-2 ml-3"
                @click="navigatePage('partnershipAvenue')"
              >
                <img
                  class="ml-3 popover-img-partner"
                  src="@/assets/dashboard/partnershipavenue.svg"
                />
                <p class="popover-text mt-2 pt-1">Partnership Avenue</p>
                <!-- <p class="popover-sub-text"> -->
                <li class="popover-sub-text">Buildings and Factories</li>
                <li class="popover-sub-text">Minerals & Metals</li>
                <li class="popover-sub-text">Transportation Infrastructure & More..</li>
                <!-- </p> -->
              </div>
            </span>
            <div class="row">
              <div
                class="popover-menu-item-group cursor-pointer mt-3"
                @click="navigatePage('featuredProjects')"
              >
                <img class="ml-3 popover-img-project" src="@/assets/dashboard/featuredprojects.svg" />
                <p class="popover-text mt-2">Featured Projects</p>
                <!-- <p class="popover-sub-text">
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                  sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                </p>-->
                <li class="popover-sub-text">Mumbai International Airport</li>
                <li class="popover-sub-text">Motera, Stadium</li>
                <li class="popover-sub-text">Delhi Metro & More..</li>
              </div>
            </div>
          </div>
          <div class="col-1"></div>
        </div>
      </b-popover>

      <b-button
        class="partnerHome-nav-button m-0 p-0 ml-5 mb-2 mt-2"
        id="popover-partner-portal"
      >Partner Portal</b-button>
      <b-popover
        :show.sync="showPartnerMenu"
        target="popover-partner-portal"
        custom-class="partner-popover-container"
        triggers="hover blur"
        placement="top"
      >
        <div class="popover-partner-portal row">
          <!-- <div class="col-5">
            <p class="ml-5 pl-3 mt-2 pt-3">
              <img src="@/assets/dashboard/lntlogo.svg" />
            </p>
            <p class="popover-text pl-3 ml-5">L&T Partner Portal</p>
            <div class="m-0 p-0 pt-1">
              <img class="lnt-background" src="@/assets/dashboard/lntbackground.svg" />
            </div>
          </div>-->
          <div class="partner-menu-item-group col-2 pt-5">
            <div
              v-for="(data, index) in partnerPortalData"
              :key="index"
              class="row cursor-pointer popover-subheading-text ml-3"
              :class="checkActiveField(index)"
              @mouseover="changeChildrenOnHover(data)"
              @click="activeChildren(data)"
            >
              <p
                class="popover-menu-item-heading d-inline-block mr-0 pr-0"
              >{{ data.text }}&nbsp;&nbsp;</p>
              <!-- <img
                v-if="data.children && data.children.length"
                class="menu-item-arrow pl-n1 ml-n1"
                src="@/assets/home-page-images/bannerRightIcon.png"
                alt
              />-->
            </div>
          </div>
          <div class="col-3 mt-5">
            <div
              v-for="(data, index) in childrenData"
              :key="index"
              class="ml-3 cursor-pointer"
              @click="data.alternateText
                  ? navigatePage(data.alternateText)
                  : navigatePage(data.childText)
              "
            >
              <span v-if="index < 4">
                <p class="popover-menu-item popover-text">{{ data.childText }}</p>
                <p class="popover-sub-text" v-html="data.description"></p>
              </span>
            </div>
          </div>
          <div class="col-2"></div>
          <div class="col-3 mt-5">
            <div
              v-for="(data, index) in childrenData"
              :key="index"
              class="ml-3 cursor-pointer"
              @click="data.alternateText
                  ? navigatePage(data.alternateText)
                  : navigatePage(data.childText)
              "
            >
              <span v-if="index >= 4">
                <p class="popover-menu-item popover-text">{{ data.childText }}</p>
                <p class="popover-sub-text" v-html="data.description"></p>
              </span>
            </div>
          </div>
          <div class="col-6"></div>
        </div>
      </b-popover>

      <b-button class="partnerHome-nav-button m-0 p-0 ml-5 mb-2 mt-2" id="popover-feedback">FeedBack</b-button>
      <b-popover
        :show.sync="showFeedbackMenu"
        target="popover-feedback"
        custom-class="feedback-popover-container"
        triggers="hover blur"
        placement="top"
      >
        <div class="popover-feedback row">
          <!-- <div class="col-5">
            <p class="ml-5 pl-3 mt-5 pt-3">
              <img src="@/assets/dashboard/lntlogo.svg" />
            </p>
            <p class="popover-text pl-3 ml-5">L&T Constructions FeedBack</p>
            <div class="m-0 p-0">
              <img class="lnt-background" src="@/assets/dashboard/lntbackground.svg" />
            </div>
          </div>-->
          <div class="m-auto">
            <span class="row mb-5">
              <div
                class="col-6 popover-menu-item-group cursor-pointer mt-4 pt-3"
                @click="navigatePage('suggestions')"
              >
                <img class="m-auto popover-img-suggestion" src="@/assets/dashboard/feedback.svg" />
                <p class="pt-2 cursor-pointer popover-text mt-2 pt-4">Suggestions & FeedBack</p>
                <p
                  class="popover-sub-text"
                >Partner can provide feedback and suggestions based on the experience they had on the site and in additional it also helps us to improve.</p>
              </div>
              <!-- <span class="popover-text">Company Overview</span> -->
              <div
                class="col-6 popover-menu-item-group cursor-pointer pt-2 mt-4"
                @click="navigatePage('testimonials')"
              >
                <img class="m-auto popover-img-testmional" src="@/assets/dashboard/testmional.svg" />
                <p class="pt-2 cursor-pointer popover-text mt-2">Testimonials</p>
                <p class="popover-sub-text">
                  <strong>Ramco Cements</strong> - The existing website is user friendly .The new system developed is also more user friendly and highly informative and we hope that it will serve all the needs of the vendors &
                  <br />More...
                </p>
              </div>
            </span>
          </div>
          <!-- <div class="col-1"></div> -->
        </div>
      </b-popover>

      <b-button class="m-0 p-0 ml-5 mb-2 mt-2" @click="navigatePage('contact-us')">Contact Us</b-button>


    </div>

    <w-modal
      :trigger="triggerModal"
      :text="lastResponse"
      :title="modalTitle"
      :centered="true"
      :dontCloseWhenClickedOutside="true"
      :dontCloseWhenEscapePressed="true"
      :dontShowCloseIcon="false"
      :modalbuttonStyle="true"
      :showAlert="alertModal"
      :showSuccess="successModal"
      :browserMessage="isBrowserMessage"
      @eventClose="changeModalSuccess()"
    />

    <!-- Home Page -->

    <div v-if="selectedTab == 'home'" id="home" class="background-animate">
      <div class="bannerCard" data-aos="zoom-in" style="width: 70%">
        <!-- <div class="bannerCard" > -->
        <b-card title="Be more than just a vendor" class="py-2 text-left card-style">
          <div class="row">
            <b-card-text class="text-left ml-3">Let's Partner...</b-card-text>
            <b-button @click="goToRegisterPage()">
              Register
              <img src="@/assets/home-page-images/bannerRightIcon.png" alt />
            </b-button>
          </div>
        </b-card>
      </div>
    </div>
    <app-about :selectedTab="selectedTab"></app-about>
    <app-footer></app-footer>
    <!-- <transition name="fade">
      <div @click="scrollToTop()" v-if="showScrollUpBtn" class="go-up">
        <span>
          <font-awesome-icon icon="arrow-up" size="2x" style="color:#2c3e50;margin-top:13px" />
        </span>
      </div>
    </transition>-->
  </div>
</template>

<script>
import AboutLnTVue from "../components/homepage/AboutLnT";
import FooterVue from "../components/homepage/Footer";
import widgetModal from "../widgets/newModalWidget";

// import ChatVue from "../components/homepage/Chat";

export default {
  name: "home",
  components: {
    appAbout: AboutLnTVue,
    appFooter: FooterVue,
    "w-modal": widgetModal
    // appChat: ChatVue
  },
  data() {
    return {
      chromeMessageViewed: window.localStorage.getItem("ChromeMessageViewed"),
      showScrollUpBtn: false,
      childrenData: [],
      showPopoverMenu: false,
      showFeedbackMenu: false,
      showPartnerMenu: false,
      triggerModal: false,
      lastResponse: "",
      alertModal: false,
      successModal: false,
      isBrowserMessage: false,
      partnerPortalData: [
        {
          text: "Partner Portal",
          activeNode: 1,
          children: [
            {
              childText: "Partner Overview",
              description:
                "<p> Partner Portal - on demand market intelligence - will serve as high quality source of information,for all stakeholders to improve efficiency and performance.&nbsp;&nbsp; <br/> More...</p>"
            },
            // {
            //   childText: "Partner Portal",
            //   description:
            //     "<p> • On demand market intelligence - will serve as high quality source of information, for all stakeholders to improve efficiency and performance. <br/> •Product is designed to evaluate & on board elite partners to engage in prolific business with L&T.</p>"
            // },
            {
              childText: "Partner With L&T",
              alternateText: "Partner With LandT",
              description:
                "<p> A business supported by partners with multiple talents and visions significantly increases opportunitiesA business supported by partners with multiple talents and visions significantly increases opportunities to <br/>  •	Acquire New Customers <br/> •	Increase Revenue <br/> • Expand Geographic Reach &nbsp;&nbsp; <br/> More.. </p>"
            }
          ]
        },
        {
          text: "Partner Interface",
          activeNode: 2,
          children: [
            {
              childText: "Partner Register",
              description:
                "Registering with L&T is a very simple and easy process. It creates a unique identity for a partner and helps in initiating business."
            },
            {
              childText: "Partner Onboard",
              description:
                "On Boarding process helps realize potential and capability of the partner. It also helps in identifying the business avenues and services the partner is interested in."
            },
            {
              childText: "Feedback Questionnaire",
              description:
                "This portal enables partners to provide feedback where he has rendered services. This helps in having more transparent business transactions and more enriching user experience <br/> More.."
            },
            {
              childText: "Partner Bills & Payments",
              alternateText: "Partner Bills and Payments",
              description:
                "Provision to enable the partneres to register BG,Invoice with refrence to the supply and services to be offered / Offered by them </br> Navigation path:   Partner Portal --> Login --> Dashboard --> Partner Invoice "
            }
          ]
        },
        {
          text: "Partner Management",
          activeNode: 3,
          children: [
            {
              childText: "Empanelment",
              description:
                "To facilitate LTC team with streamlined qualify partners by engaging them to do business for a defined period with  pre-approved values for specific business category"
            },
            {
              childText: "E-Sourcing",
              description:
                "E Sourcing helps a partner to know about the RFQ floated and participate based on the eligible categories of business / expertise"
            },
            {
              childText: "Contract Management",
              description:
                "This module helps  L & T  to see the overall performance of the partner. It helps to evaluate the partners on various KPIs across various projects"
            },
            {
              childText: "Performance Management",
              description:
                "Every partner is evaluated on the performance based on the standard metrics. Partner are evaluated on key attributes based on the services rendered."
            },
            {
              childText: "PO / WO Acceptance",
              description:
                "Enables the partner to accept and confirm their intrest to engage in business with us by accepting the orders offers to them"
            },
            {
              childText: "Partner Status",
              description:
                "This helps L & T to identify partners with continuity in business. This eases out the RFQ process and helps in awarding orders fastly"
            }
          ]
        },
        {
          text: "Partner MarketPlace",
          activeNode: 4,
          children: [
            {
              childText: "Price Discovery",
              description:
                "Price discovery is the central function of a marketplace and is the process of finding out the price of a given asset or commodity or service.<br/>More.."
            },
            {
              childText: "Catalogue Management",
              description:
                "• Build a smart <br/> • Accessible and neat catalogue for product Leverage the benefits of great content <br/> • To suit business"
            }
          ]
        },
        {
          text: "Dashboard",
          activeNode: 5,
          children: [
            {
              childText: "Partner Dashboard",
              description:
                "Partners can have a snapshot of their business with L & T in this module. It gives a comprehensive picture of their performance on various aspects"
            },
            {
              childText: "Buyer Dashboard",
              description:
                "Buyers can have a summary of the partner’s performance in this module. It helps the buyer to analyse his performance for future business transactions"
            },
            {
              childText: "Employees Dashboard",
              description:
                "Employees can get a snapshot of partner’s performance which helps them to monitor the progress of the job"
            },
            {
              childText: "Senior Management",
              description:
                "Senior Management gets a overall picture of a partner’s performance through this module. It helps the senior management to properly channelize the resources at a project"
            }
          ]
        }
      ],
      selectedTab: "home"
    };
  },
  created() {
    window.localStorage.removeItem("eid");
    window.addEventListener("scroll", this.onScroll);
    //this.browserCheck();
  },
  destroyed() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    goToRegisterPage() {
      this.$router.push("/registration");
    },
    scrollToTop() {
      console.log("up");
      document.scrollingElement.scrollTop = 0;
    },
    onScroll(e) {
      const scrollTop = document.scrollingElement.scrollTop;
      this.showScrollUpBtn = scrollTop > 150;
    },
    activeChildren(data) {
      if (data.children) {
        this.childrenData = [];
        this.childrenData = data.children;
      } else {
        this.navigatePage(data.text);
      }
    },
    changeChildrenOnHover(data) {
      this.selectedTab = "home";
      console.log(data);
      if (data.children && data.activeNode) {
        this.childrenData = [];
        this.activeNode = data.activeNode;
        this.childrenData = data.children;
      } else {
        this.childrenData = [];
      }
    },
    checkActiveField(index) {
      console.log(index);
      if (index + 1 == this.activeNode) {
        return "popover-subheading-hover";
      }
    },
    navigatePage(selectedPage) {
      console.log(selectedPage);
      this.showPopoverMenu = false;
      this.showPartnerMenu = false;
      this.showFeedbackMenu = false;
      // console.log("Selected Page : " + selectedPage);
      switch (selectedPage) {
        case "home":
          this.selectedTab = "home";
          break;
        case "Partner Portal":
          this.$router.push("/designPage");
          break;
        case "Partner Register":
          this.$router.push("/registration");
          break;
        case "Partner Onboard":
          this.$router.push("/login");
          break;
        case "Partner Bills and Payments":
          console.log("");
          //Routing goes Here...
          this.selectedTab = "home";
          break;
        case "Partner Dashboard":
          console.log("");
          this.$router.push("/login");
          //Routing goes Here...
          break;
        case "Buyer Dashboard":
          console.log("buyer");
          //Routing goes Here...
          this.selectedTab = "home";
          break;
        case "Employees Dashboard":
          console.log("");
          //Routing goes Here...
          this.selectedTab = "home";
          break;
        case "Senior Management":
          console.log("");
          //Routing goes Here...
          break;
        case "Partner Management":
          console.log("");
          //Routing goes Here...
          break;
        case "suggestions":
          console.log("");
          this.selectedTab = "suggestions";
          //Routing goes Here...
          break;
        case "PO / WO Acceptance":
          console.log("");
          //Routing goes Here...
          this.selectedTab = "home";
          break;

        case "Performance Management":
          window.location = process.env.VUE_APP_SUMMARYREDIRECT_URL;
          break;
        case "Empanelment":
          window.location = process.env.VUE_APP_SUMMARYREDIRECT_URL;
          break;
        case "Contract Management":
          window.location = process.env.VUE_APP_SUMMARYREDIRECT_URL;
          break;
        case "E-Sourcing":
          window.location = process.env.VUE_APP_SUMMARYREDIRECT_URL;
          break;
        case "Partner Status":
          window.location = process.env.VUE_APP_SUMMARYREDIRECT_URL;
          break;

        case "contact-us":
          if (document.getElementById("footer"))
            document.getElementById("footer").scrollIntoView(true);
          break;
        default:
          this.selectedTab = selectedPage;
          console.log(this.selectedTab);
          break;
      }
    },
    browserCheck() {
      if (!/chrome/i.test(navigator.userAgent) && !this.chromeMessageViewed) {
        this.triggerModal = true;
        this.alertModal = true;
        this.lastResponse =
          "We strongly recommend using Google Chrome browser to open Partner Portal.";
        this.isBrowserMessage = true;
      }
    },
    changeModalSuccess() {
      this.triggerModal = false;
      this.alertModal = false;
      this.lastResponse = "";
      this.isBrowserMessage = false;
    }
  }
};
</script>

<style scoped>
#fullscreen {
  height: 90vh;
  scroll-behavior: smooth;
  /* overflow-y: scroll; */
}

#home {
  height: 100%;
  background-image: url("../assets/home-page-images/banner.jpg");
  background-size: cover;
  background-position: center;
  position: relative;
  font-family: "Montserrat", sans-serif;
}
.bannerCard {
  position: absolute;
  left: 10%;
  top: 37%;
}
.partnerHome-nav-bar {
  background: #002d72;
}
.partnerHome-nav-bar .btn-secondary,
.partnerHome-nav-bar .btn-secondary:hover,
.partnerHome-nav-bar .btn-secondary:focus,
.partnerHome-nav-bar .btn-secondary:active {
  color: #ffffff !important;
}
.partnerHome-nav-bar .btn-secondary:hover {
  transform: scale(1.2) !important;
}
.bannerCard .py-2 {
  border-radius: 0;
}
.card-title {
  font-weight: 600;
  font-size: 24px;
  color: #4e4e4e;
}
.card-text {
  font-size: 26px;
  color: #002d72;
  font-weight: 700;
}
.btn-secondary,
.btn-secondary:hover,
.btn-secondary:focus,
.btn-secondary:active {
  background-color: transparent !important;
  box-shadow: none !important;
  border: none;
  color: #002257 !important;
  padding-left: 0;
  text-transform: uppercase;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: 700;
  letter-spacing: 2.5px;
  margin-left: 33%;
  margin-bottom: 2%;
}
.btn-secondary img {
  width: 18px;
  margin-left: 5px;
  margin-bottom: 2px;
}
.card-style {
  /*width: 150% !important;
  height: 130px !important;*/
}
.animate-area:hover {
  transform: scale(1.1) !important;
}
@keyframes bg-move {
  25% {
    background-size: 100%;
  }
  /* Adding a step in the middle */
  /* 25% {
    background-size: 110%;
  } */
  50% {
    background-size: 115%;
  }
  /* 75% {
    background-size: 110%;
  } */
  100% {
    background-size: 100%;
  }
}
.popover-data {
  height: 50vh !important;
  width: 80vh !important;
}
.background-animate {
  animation: bg-move 15s ease-in-out infinite;
}
.go-up {
  /* display: block;
  height: 52px;
  width: 52px;
  position: fixed;
  bottom: 47px;
  right: 15px;
  z-index: 700;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: -1px 1px 5px #00000080;c
  cursor:pointer; */

  width: 62px;
  height: 62px;
  position: fixed;
  bottom: 47px;
  left: 40px;
  cursor: pointer;
  z-index: 700;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: -1px 1px 5px #00000080;
  display: block;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.popover-text {
  font-size: calc(12px + (16 - 12) * ((100vw - 300px) / (1600 - 300)));
  font-weight: bold;
  font-family: "Open Sans", sans-serif;
}
.popover-subheading-text {
  font-size: calc(12px + (16 - 12) * ((100vw - 300px) / (1600 - 300)));
  font-weight: bold;
  font-family: "Open Sans", sans-serif;
}
.popover-text:hover {
  color: rgb(73, 140, 210);
}
.popover-subheading-hover {
  font-size: calc(12px + (16 - 12) * ((100vw - 300px) / (1600 - 300)));
  color: rgb(73, 140, 210);
  /* background-color: #dfedf7 !important; */
}
.popover-sub-text {
  width: 35vw;
  color: #b5b5b5 !important ;
}
.lnt-background {
  height: 230px !important;
  width: 100% !important;
}
.menu-item-arrow {
  padding-top: 10px;
  height: 22px;
  width: 20px;
  display: inline-block;
}
.popover-about {
  max-height: calc(100vh - 170px) !important;
  min-height: calc(100vh - 170px) !important;
  overflow-y: scroll;
  padding-bottom: 30px !important;
  background-image: url("../assets/dashboard/lntbackground.svg");
  color: white;
  background-position: right bottom;
}
.popover-partner-portal {
  max-height: calc(100vh - 170px) !important;
  min-height: calc(100vh - 170px) !important;
  overflow-y: scroll;
  padding-bottom: 30px !important;
  margin: 0px !important;
  background-image: url("../assets/dashboard/lntbackground.svg");
  color: white;
  background-position: right bottom;
}
.popover-menu-item:hover {
  color: rgb(73, 140, 210);
}
.popover-menu-item-group:hover {
  color: rgb(73, 140, 210);
}
.popover-menu-item-heading {
  font-weight: bold;
  font-family: "Open Sans", sans-serif;
  font-size: "21px" !important;
}
.popover {
  max-width: 50% !important;
}
.about-popover-container {
  min-width: 100% !important;
  min-height: calc(100vh - 170px) !important;
  max-height: 100vh;
  height: auto;
  background-color: #232f3e;
  margin-left: -20px;
  font-size: calc(10px + (14 - 10) * ((100vw - 300px) / (1600 - 300)));
}
.partner-popover-container {
  min-width: 100% !important;
  min-height: calc(100vh - 170px) !important;
  max-height: 100vh;
  background-color: #232f3e;
  overflow: visible;
  margin-left: -20px;
  float: left;
  font-size: calc(10px + (14 - 10) * ((100vw - 300px) / (1600 - 300)));
}
.partner-menu-item-group {
  border-right: 1px solid #141a22;
}
.feedback-popover-container {
  min-width: 100% !important;
  min-height: calc(100vh - 170px) !important;
  max-height: 100vh;
  height: auto;
  background-color: #232f3e;
  margin-left: -20px;
  float: left;
  font-size: calc(10px + (14 - 10) * ((100vw - 300px) / (1600 - 300)));
}
.popover-feedback {
  max-height: calc(100vh - 170px) !important;
  min-height: calc(100vh - 170px) !important;
  overflow-y: scroll;
  padding-bottom: 30px !important;
  color: white;
  background-image: url("../assets/dashboard/lntbackground.svg");
  background-position: right bottom;
}
.side-popover {
  background-color: #fafafa;
}
.popover-img-company {
  max-width: 80px !important;
  max-height: 80px !important;
}
.popover-img-partner {
  max-width: 104px !important;
  max-height: 104px !important;
}
.popover-img-project {
  max-width: 90px !important;
  max-height: 90px !important;
}
.popover-img-testmional {
  max-width: 92px !important;
  max-height: 92px !important;
}
.popover-img-suggestion {
  max-width: 160px !important;
  max-height: 70px !important;
}
.partnerHome-nav-bar .popover {
  margin-top: 7px !important;
  min-width: 70% !important;
  max-height: 100vh !important;
}
</style>